import "./Timer.css"

const Timer = ({ mainClassName, glowBackId, timerTextClassName, timerTextId, time }) => {
    return <div className={`button-container ${mainClassName}`}>
        <div id={glowBackId}></div>
        <div className="inner-button">
            <div className="gloss"></div>
            <span className={`timer_text ${timerTextClassName}`} id={timerTextId}>{time} </span>
        </div>
    </div>
}

export default Timer